// eslint-disable-next-line no-useless-escape
export default new RegExp('^https?:\\/\\/(www.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9()@:%_\\+.~#?&//=]*)$')
